
import Vue from 'vue';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo } from './api/wap';
import { Toast } from 'vant';

const baseUrl = 'cqcc';

export default Vue.extend({
  name: 'ViewHolder',
  components: {
    BottomTabbar,
  },
  data() {
    return {
      tabs: [
        {
          title: '投稿入口',
          path: `/${baseUrl}/home`,
          id: 1,
        },
        {
          title: '相关新闻',
          path: `/${baseUrl}/news`,
          id: 2,
        },
        {
          title: '大赛信息',
          path: `/${baseUrl}/rule`,
          id: 3,
        },
      ] as any[],
      activeTab: 0,
      baseInfo: {} as any,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.onRouteChange();
      },
    },
  },
  async mounted() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();

    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  },
  methods: {
    onRouteChange() {
      const cover =
        'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
      this.$appShareInfo({
        title: '2026年重庆市大学生创意传播作品大赛',
        subtitle: '记录时代脉搏 激扬青年声音',
        image: cover,
        url: location.href,
        id: 0,
        type: -1,
        columnId: 0,
      });
      if (isWeiXin()) {
        this.$wxShareInfo({
          title: '2026年重庆市大学生创意传播作品大赛',
          subtitle: '记录时代脉搏 激扬青年声音',
          image: cover,
        });
      }
    },
    toUser() {
      if (window.udid) {
        this.$router.push('user');
      } else {
        this.$dialog
          .confirm({
            title: '友情提示',
            message: '请在上游新闻App参与',
            confirmButtonText: '还没装？一步安装',
            cancelButtonText: '我已安装过',
            closeOnClickOverlay: true,
          })
          .then((action) => {
            console.log(action);
            window.location.href = 'https://wap.cqcb.com/download';
          })
          .catch((action) => {
            console.log(action);
            if (action === 'overlay') {
              // 忽略掉点击遮罩层的关闭行为
              return;
            }
            if (isWeiXin()) {
              Toast('请在浏览器打开');
            } else {
              const openAndroidUrl =
                'https://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews&&android_schema=shangyounews://jump.cqcb.com/applink/jump.html';
              const openIosHmUrl = 'https://jump.cqcb.com/applink/jump.html';
              const data1 = '{"dt":"7","url":"' + document.location.href + '"}';

              if (window.isAndroid) {
                window.location.href = `${openAndroidUrl}?data=${data1}`;
              } else {
                window.location.href = `${openIosHmUrl}?data=${data1}`;
              }
            }
          });
      }
    },
  },
});
